import { expandAdminPermissions } from "./adminPermissions";
import { components } from "react-select";
import { store } from "../index";
import i18next from "i18next";
import { defaultDropdownValue } from "store/reducers/inspectionPerfomanceReducer";
import { appendSasToken } from "./azureSas";

class Helper {
  static getCompanyId = () => {
    if (localStorage.getItem("inperosnateId")) {
      return +localStorage.getItem("inperosnateId");
    }
    return null;
  };

  static getUserPermissions = () => {
    if (
      localStorage.getItem("inperosnateId") &&
      localStorage.getItem("user_company_users")
    ) {
      const retrievedObject = localStorage.getItem("user_company_users");
      const userProfile = JSON.parse(retrievedObject);
      return expandAdminPermissions(userProfile
        .filter(
          (item) => item.company === +localStorage.getItem("inperosnateId")
        )
        .map((dataitem) => dataitem.permissions)
        .flatMap((flat) => flat)
        .map((final) => final.codename));
    }
    return null;
  };

  static isCurrentCompanyPrimaryOrSecondaryAdmin = (...profiles) => {
    const companyId = Helper.getCompanyId();
    if (!companyId) {
      return false;
    }

    return profiles
      .filter(Boolean)
      .flatMap((profile) => profile.user_company_users || [])
      .some((membership) =>
        Number(membership.company) === companyId &&
        [1, 2].includes(Number(membership.type)) &&
        membership.is_active !== false
      );
  };

  static isLoggedIn = () => {
    return localStorage.getItem("private_token") ? true : false;
  };

  static isTwoFactor = () => {
    return localStorage.getItem("two_factor") ? true : false;
  };

  static validateSamePassword = (newPassword, confrimPassword) => {
    if (newPassword === confrimPassword) {
      return true;
    }

    return false;
  };

  static validateSpace = (value) => {
    if (value.trim() == "") {
      return true;
    }
    return false;
  };

  static validateNumber = (number) => {
    // && number.length >= 10 && number.length <= 10
    if (number.length >= 10 && number.length <= 10) {
      // ^\+?[\(\)\d-]+$
      return true;
    }
    return false;
  };

  static validatePassword = (passwordValue) => {
    if (
      /^\w+$/.test(passwordValue) &&
      passwordValue.length >= 6 &&
      passwordValue.length <= 15
    ) {
      return true;
    }

    return false;
  };

  static validateAlphabet = (value) => {
    if (!/^[0-9a-zA-Z!@#\$%\^\&*\)\(+=._-]+$/g.test(value)) {
      return true;
    }

    return false;
  };

  static validateNumeric = (value) => {
    if (!/^\d+$/.test(value)) {
      return true;
    }

    return false;
  };

  static validatePostcode = (code) => {
    if (/^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/i.test(code)) {
      return true;
    }

    return false;
  };

  static validateUSAPostcode = (code) => {
    if (/^[0-9]{5}(?:-[0-9]{4,5})?$/.test(code)) {
      return true;
    }

    return false;
  };

  static validateEmail = (email) => {
    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      return true;
    }

    return false;
  };

  static formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return null;
  };
}

export function JSON_to_URLEncoded(element, key, list) {
  var list = list || [];
  if (typeof element == "object") {
    for (var idx in element)
      JSON_to_URLEncoded(element[idx], key ? key + "[" + idx + "]" : idx, list);
  } else {
    list.push(key + "=" + encodeURIComponent(element));
  }
  return list.join("&");
}

export const getImageWithToken = (imgUrl) => {
  const storeData = store.getState();
  const sasToken = storeData?.workOrder?.initialSasToken?.token;
  return appendSasToken(imgUrl, sasToken);
};

export const Option = (props) => (
  <div>
    <components.Option {...props}>
      <div className="ch-checkbox">
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <span> {props.label}</span>
      </div>
    </components.Option>
  </div>
);

export const ValueContainer = ({ children, hasValue, getValue, ...props }) => {
  if (!hasValue) {
    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );
  }
  const CHIPS_LIMIT = 4;
  const [chips, otherChildren] = children;
  const overflowCounter = getValue().length;
  const displayChips = chips.slice(0, CHIPS_LIMIT);

  if (overflowCounter > CHIPS_LIMIT) {
    return (
      <components.ValueContainer {...props}>
        {displayChips}
        {otherChildren}
        {overflowCounter > CHIPS_LIMIT ? (
          `+ ${overflowCounter - CHIPS_LIMIT}`
        ) : (
          <span style={{ width: "10px" }}></span>
        )}
      </components.ValueContainer>
    );
  }
  return (
    <components.ValueContainer {...props}>
      {displayChips}
      {otherChildren}
    </components.ValueContainer>
  );
};

export const getQueryParams = (obj = {}, customParams = {}) => {
  // Convert object to query string
  const baseParams = new URLSearchParams(obj).toString();

  // Convert custom params manually to prevent encoding issues
  const customParamsString = Object.entries(customParams)
    .map(([key, value]) => `${key}=${value}`) // Avoid URL encoding
    .join("&");

  // Combine both query strings intelligently with "?" handling
  const queryString = [baseParams, customParamsString]
    .filter(Boolean)
    .join("&");

  return queryString ? `?${queryString}` : "";
};

export const toSnakeCase = (str) =>
  str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();

export const transformData = (input) => {
  return Object.fromEntries(
    Object.entries(input).map(([key, value]) => {
      return value && typeof value === "object" && "id" in value
        ? [toSnakeCase(key), value.id === defaultDropdownValue ? "" : value.id]
        : [toSnakeCase(key), value === defaultDropdownValue ? "" : value];
    })
  );
};

export const generateHexColors = (length = 0) => {
  return Array.from({ length }, () => {
    const r = Math.floor(Math.random() * 250); // Max 250 to avoid too much brightness
    const g = Math.floor(Math.random() * 200); // Max 200 to avoid too much brightness
    const b = Math.floor(Math.random() * 200); // Max 200 to avoid too much brightness
    return `#${r.toString(16).padStart(2, "0")}${g
      .toString(16)
      .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  });
};

export const getPdfWithToken = (pdfUrl, fileName, token, translateFileName = true) => {
  const storeData = store.getState();
  const sasToken = token || storeData?.workOrder?.initialSasToken?.token;
  return appendSasToken(pdfUrl, sasToken);
};
export const getExcelWithToken = (excelUrl, fileName, token) => {
  const storeData = store.getState();
  const sasToken = token || storeData?.workOrder?.initialSasToken?.token;
  return appendSasToken(excelUrl, sasToken);
};

export const smoothScrollTo = (targetY, duration = 500) => {
  const startY = window.scrollY;
  const distance = targetY - startY;
  let startTime = null;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    // Ease in-out
    const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    const progress = Math.min(timeElapsed / duration, 1);
    const scrollY = startY + distance * ease(progress);

    window.scrollTo(0, scrollY);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }
  requestAnimationFrame(animation);
};

export const capitalize = (string) => {
  if (!string) return "";
  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const uniqueObjectsById = (data = []) =>
  Array.from(
    data
      .reduce((map, obj) => {
        // If an object with this ID does NOT exist yet, add it.
        if (!map.has(obj.id)) {
          map.set(obj.id, obj);
        }
        return map;
      }, new Map())
      .values()
  );
export const sortByName = (arr) =>
  arr
    ? [...arr].sort((a, b) => {
        if (a.name === "All") return -1; // a goes first
        if (b.name === "All") return 1;  // b goes first
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      })
    : [];
// Remove duplicates by "name" and keep the first occurrence
export const removeDuplicatesByName  = (arr = []) => {
  const seen = new Set();
  return arr.filter(item => {
    if (seen.has(item.name)) return false;
    seen.add(item.name);
    return true;
  });
};
export default Helper;
